import React from 'react'

import type { ContentSliderPartProps } from './content-slider.d';

import ContentSlider from '/react4xp/components/ContentSlider'

function ContentSliderPart(props: ContentSliderPartProps) {
    return <ContentSlider {...props} />
}

export default (props) => <ContentSliderPart {...props} />
